import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Accordion, Form } from 'react-bootstrap';
import 'react-multi-carousel/lib/styles.css';

//component
import Banner from '../banner/banner'
import Branch from './branch-list/Branchs'



function Branchs() {
 

  return (
    <>
    <div className='container bg-white p-3 m-3'>
      <div className='title pb-2'>
        <h6>صفحه شعب</h6>
      </div>
      <div className=''>
      <Accordion  >
          <div className=' [&>div]:px-2 [&>div]:py-3'>
            <div className='12'>
              <Accordion.Item eventKey="0">
                <Accordion.Header>بنر صفحه شعبه ها</Accordion.Header>
                <Accordion.Body>
                <Banner slug="branch1"/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
      
            <div>
              <Accordion.Item eventKey="2">
                <Accordion.Header>شعبه ها</Accordion.Header>
                <Accordion.Body>
                    <Branch/>
                </Accordion.Body>
              </Accordion.Item>
            </div>
            {/* <div>
              <Accordion.Item eventKey="3">
                <Accordion.Header>نظرات ثبت شده بر روی محصولات</Accordion.Header>
                <Accordion.Body>
                    <Comment/>
                </Accordion.Body>
              </Accordion.Item>
            </div> */}
           
          </div>
        </Accordion>
      </div>
    </div>
    </>
  );
}

export default Branchs;
